// This is bit confusing, but we're typing this manually so we get some sort of typechecking,
// while still being flexible enough so we can call this from anywhere.

import type { ArticleModuleEmbedFragment } from './__generated__/ArticleModuleEmbed.generated';

export function getEmbedAltText(articleModule: ArticleModuleEmbedFragment) {
	return articleModule?.embed?.altText;
}

export function getEmbedPrivacyText(articleModule: ArticleModuleEmbedFragment) {
	return articleModule?.embed?.embedService?.privacyText;
}

export function getEmbedService(articleModule: ArticleModuleEmbedFragment) {
	return articleModule?.embed?.embedService?.rowId;
}

export function getEmbedSource(articleModule: ArticleModuleEmbedFragment) {
	return articleModule?.embed?.source;
}

export function getEmbedUrl(articleModule: ArticleModuleEmbedFragment) {
	return articleModule?.embed?.url;
}

export function getCmpServiceId(articleModule: ArticleModuleEmbedFragment) {
	return articleModule?.embed?.embedService?.cmpServiceId;
}
